 
// src/utils/constants.js

// src/utils/constants.js
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || ''
};

export const CHAT_CONFIG = {
  DEFAULT_WIDTH: 450,
  DEFAULT_HEIGHT: 600,
  MIN_WIDTH: 400,
  MAX_WIDTH: 800,
  MIN_HEIGHT: 400,
  MAX_HEIGHT_VH: 80
};

export const DEFAULT_MODULES = [
  {
    id: 'dashboard',
    name: 'Chairman Dashboard',
    type: 'core',
    status: 'active',
    description: 'Global overview across all tenants'
  },
  {
    id: 'tenant-registry',
    name: 'Tenant Registry',
    type: 'core',
    status: 'active',
    description: 'Manage all Aetheris instances'
  },
  {
    id: 'global-analytics',
    name: 'Global Analytics',
    type: 'core',
    status: 'active',
    description: 'Cross-tenant intelligence and insights'
  },
  {
    id: 'update-control',
    name: 'Update Control',
    type: 'core',
    status: 'active',
    description: 'Push updates and rollbacks to tenants'
  },
  {
    id: 'knowledge-layer',
    name: 'Global Knowledge Layer',
    type: 'core',
    status: 'active',
    description: 'Federated intelligence aggregation'
  },
  {
    id: 'team',
    name: 'Chairman Team',
    type: 'core',
    status: 'active',
    description: 'Manage Chairman-level users'
  },
];

export const COLORS = {
  PRIMARY: '#3b82f6',
  SECONDARY: '#8b5cf6',
  SUCCESS: '#22c55e',
  WARNING: '#f59e0b',
  DANGER: '#ef4444'
};
